import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton", "typeField"];

  connect() {
    this.syncTypeFromCheckedRadio();
    this.updateSubmitButton();
  }

  selectPlan(event) {
    if (this.hasTypeFieldTarget) {
      this.typeFieldTarget.value = event.currentTarget.dataset.type || "";
    }
    this.updateSubmitButton();
  }

  syncTypeFromCheckedRadio() {
    const checkedRadio = this.element.querySelector('input[name="plan"]:checked');
    if (checkedRadio && this.hasTypeFieldTarget) {
      this.typeFieldTarget.value = checkedRadio.dataset.type || "";
    }
  }

  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return;
    this.submitButtonTarget.disabled = !this.element.querySelector('input[name="plan"]:checked');
  }
}
